import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import Api from "../api/Api";
import Form from "../controls/Form";
import Select from "../controls/Select";
import Modal from "../layout/Modal";
import Input from "../controls/Input";
import Checkbox from "../controls/Checkbox";

export default forwardRef(function SegmentModal({ segments, onSelected }, ref) {

	useImperativeHandle(ref, () => ({
		show,
	}));

	const form = useRef();
	const modal = useRef();
	const [oActivities, setActivities] = useState([]);
	const [oSegments, setSegments] = useState([]);
	const [oSubsegments, setSubsegments] = useState([]);

	const show = () => {
		setActivities([...new Set(segments.map(s => s.activity))].map(e => [e, e]));
		form.current?.setValues({ Activity: null, Segment: null, Subsegment: null, roSegment: '', roCompliance: false, roQrvi: false });
		modal.current.setActions([
			<span className="btn btn-secondary" data-bs-dismiss="modal">{t.commonCancel}</span>,
			<span className="btn btn-primary disabled">{t.commonSend}</span>]);
		modal.current.show();
	}

	const activityChanged = val => {
		setSegments([...new Set(segments.filter(s => s.activity == val).map(s => s.segment))].map(e => [e, e]));
		setSubsegments([]);
		form.current.setValues({ Segment: null, Subsegment: null, roSegment: '', roCompliance: false, roQrvi: false });
	}

	const segmentChanged = val => {
		let activity = form.current.state.Activity;
		setSubsegments([...new Set(segments.filter(s => s.activity == activity && s.segment == val).map(s => s.subsegment))].map(e => [e, e]));
		form.current.setValues({ Subsegment: null, roSegment: '', roCompliance: false, roQrvi: false });
		modal.current.setActions([
			<span className="btn btn-secondary" data-bs-dismiss="modal">{t.commonCancel}</span>,
			<span className="btn btn-primary disabled">{t.commonSend}</span>]);
	}

	const subsegmentSelected = () => {
		let vals = form.current.state;
		onSelected({
			Subsegment: vals.roSegment,
			Compliance: vals.roCompliance,
			Qrvi: vals.roQrvi,
		});
	}

	const subsegmentChanged = val => {
		if (!val) return;
		let activity = form.current.state.Activity;
		let _segment = form.current.state.Segment;
		let found = segments.find(s => s.activity == activity && s.segment == _segment && s.subsegment == val);
		form.current.setValues({ roSegment: found.segmentId + " / " + val, roCompliance: found.compliance, roQrvi: found.qrvi });
		modal.current.setActions([
			<span className="btn btn-secondary" data-bs-dismiss="modal">{t.commonCancel}</span>,
			<span className="btn btn-primary" data-bs-dismiss="modal" onClick={subsegmentSelected}>{t.commonSend}</span>]);
	}

	return (<Modal title={t.cardSegmentSelect} ref={modal}>
		<Form ref={form}>
			<Select label={t.cardSegmentActivity} name="Activity" options={oActivities} onChange={activityChanged} sortAZ required />
			<Select label={t.cardSegmentSegment} name="Segment" options={oSegments} onChange={segmentChanged} sortAZ required readOnly={!oSegments.length} />
			<Select label={t.cardSegmentSubsegment} name="Subsegment" options={oSubsegments} onChange={subsegmentChanged} sortAZ required readOnly={!oSubsegments.length} />
			<hr />
			<Input label={t.cardSubsegment} name="roSegment" readOnly />
			<Checkbox label={t.cardCompliance} name="roCompliance" readOnly />
			<Checkbox label={t.cardQrvi} name="roQrvi" readOnly />
		</Form>
	</Modal>
	);
})